export default function initCookieConsent() {
  const CONSENT_KEY = 'cookie-consent';
  const ANALYTICS_KEY = 'analytics-consent';

  const banner = document.getElementById('cookie-consent');
  const settingsModal = document.getElementById('cookie-settings');
  const analyticsCheckbox = document.getElementById('cookie-analytics');

  if (!banner) {
    return;
  }

  // Check if consent has already been given
  const consent = localStorage.getItem(CONSENT_KEY);

  if (!consent) {
    // Show banner on first visit
    showBanner();
  } else {
    // Load analytics if consent was given
    const analyticsConsent = localStorage.getItem(ANALYTICS_KEY);
    if (analyticsConsent === 'true') {
      loadAnalytics();
    }
  }

  // Accept all button
  const acceptButton = document.querySelector('[data-cookie-accept]');
  if (acceptButton) {
    acceptButton.addEventListener('click', () => {
      saveConsent(true);
      hideBanner();
      loadAnalytics();
    });
  }

  // Reject button (only necessary cookies)
  const rejectButton = document.querySelector('[data-cookie-reject]');
  if (rejectButton) {
    rejectButton.addEventListener('click', () => {
      saveConsent(false);
      hideBanner();
    });
  }

  // Settings button
  const settingsButton = document.querySelector('[data-cookie-settings]');
  if (settingsButton) {
    settingsButton.addEventListener('click', () => {
      hideBanner();
      showSettings();
    });
  }

  // Close settings modal
  const closeButtons = document.querySelectorAll('[data-settings-close]');
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      hideSettings();
    });
  });

  // Save settings button
  const saveButton = document.querySelector('[data-settings-save]');
  if (saveButton) {
    saveButton.addEventListener('click', () => {
      const analyticsEnabled = analyticsCheckbox.checked;
      saveConsent(analyticsEnabled);
      hideSettings();

      if (analyticsEnabled) {
        loadAnalytics();
      }
    });
  }

  // Update checkbox based on current consent
  if (analyticsCheckbox) {
    const currentConsent = localStorage.getItem(ANALYTICS_KEY);
    analyticsCheckbox.checked = currentConsent === 'true';
  }

  // Helper functions
  function showBanner() {
    banner.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cookie-consent-visible');
  }

  function hideBanner() {
    banner.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cookie-consent-visible');
  }

  function showSettings() {
    settingsModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }

  function hideSettings() {
    settingsModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  function saveConsent(analyticsEnabled) {
    localStorage.setItem(CONSENT_KEY, 'true');
    localStorage.setItem(ANALYTICS_KEY, analyticsEnabled ? 'true' : 'false');
  }

  function loadAnalytics() {
    // Dispatch custom event that analytics scripts can listen to
    window.dispatchEvent(new CustomEvent('analyticsConsentGiven'));

    // Set flag for inline scripts to check
    window.analyticsConsent = true;

    // Load Matomo
    if (typeof _paq === 'undefined') {
      loadMatomoScript();
    }

    // Load Fathom
    if (!document.querySelector('script[src*="usefathom.com"]')) {
      loadFathomScript();
    }
  }

  function loadMatomoScript() {
    window._paq = window._paq || [];
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);

    const script = document.createElement('script');
    script.async = true;
    script.src = '//js-matomo.frb.io/matomo.js';

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    _paq.push(['setTrackerUrl', '//js-matomo.frb.io/matomo.php']);
    _paq.push(['setSiteId', '1']);
  }

  function loadFathomScript() {
    const script = document.createElement('script');
    script.src = 'https://cdn.usefathom.com/script.js';
    script.setAttribute('data-site', 'UZEGYTLK');
    script.defer = true;
    document.head.appendChild(script);
  }

  // Expose function to open settings from privacy page
  window.openCookieSettings = function() {
    showSettings();
  };
}
